import { FormProvider, useForm } from "react-hook-form";
import {
  FormStep1,
  FormStep10,
  FormStep11,
  FormStep3,
  FormStep4,
  FormStep5,
  FormStep6,
  FormStep8,
  FormStep12,
  FormStep13,
} from "./steps";
import { getErrorMessage, submitForm } from "../../lib/utils";
import {
  useAppContext,
  useFormDataContext,
  useLendersContext,
  useZipContext,
} from "../../lib/contexts";
import { CustomLoader } from "../CustomComponents";
import isEmpty from "lodash/isEmpty";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { normalizeForQueryParams } from "../../lib/utils/maoQueryMapper";
import EstimateCard from "../MainPage/Sections/EstimateCard";

function Form() {
  const { appContext } = useAppContext();
  const { formData, clearStorage, updateFormData } = useFormDataContext({});
  const methods = useForm({ defaultValues: formData, mode: "onSubmit" });
  const { step } = formData;
  const [isLoading, setIsLoading] = useState(false);
  const { formState } = methods;
  const { errors } = formState;
  const className = `stepBar step${step}`;
  const navigate = useNavigate();
  const { setLendersContext } = useLendersContext();
  const { isAbTesting } = useZipContext();


  const handleGlobalSubmit = async (data) => {
    const combinedData = { ...data, ...formData, ...appContext };
    setIsLoading(true);

    await new Promise((resolve) => {
      setTimeout(resolve, 1000);
    });

    Object.keys(data).forEach((key) => {
      if (formData[key] === "" && data[key] !== "") {
        combinedData[key] = data[key];
      }
    });

    const submitResult = await submitForm(combinedData);

    let pixel = null;

    if (submitResult.pixel) {
      pixel = submitResult.pixel;
    }

    const lendersContextData = {
      name: `${formData.firstname} ${formData.lastname}`,
    };

    if (submitResult.lenders && submitResult.lenders.length) {
      lendersContextData.lenders = submitResult.lenders;
    }

    setLendersContext(lendersContextData);

    const queryParams = new URLSearchParams(normalizeForQueryParams(combinedData)).toString(); 
    const encodedParams = queryParams.replace(/\+/g, '%20').replace(/%40/g, '@');
    setIsLoading(false);

    if (submitResult.status == "matched" && submitResult.lenders) {
      await navigate("/thank-you-lender-list", { state: { pixel: pixel } });
    } else {
      await navigate(`/thank-you?${encodedParams}`, {
        state: { pixel: pixel, status: submitResult.status },
      });
    }

    clearStorage();
  };

  useEffect(() => {
    if (appContext.prepop) {
      updateFormData({
        firstname: appContext.prepop.firstname || formData.firstname,
        lastname: appContext.prepop.lastname || formData.lastname,
        email: appContext.prepop.email || formData.email,
        phone: appContext.prepop.phone || formData.phone,
        zip: formData.zip || appContext.prepop.zip,
        address: appContext.prepop.address || formData.address,
      });
    }
  }, [appContext]);

  useEffect(() => {
    if (!isNaN(step) && step !== formData.step) {
      updateFormData({ ...formData, step });
    }

    const currentParams = new URLSearchParams(window.location.search);

    if (isAbTesting && !currentParams.get("ab")) {
      currentParams.set("ab", "true");
    }

    const targetPath = `/form/step${formData.step}?${currentParams.toString()}`;
    const currentPath = `${window.location.pathname}${window.location.search}`;

    if (targetPath !== currentPath) {
      navigate(targetPath, { replace: true });
    }
  }, [formData.step, step, isAbTesting]);


  return (
    <>
      <CustomLoader isLoading={isLoading} />
      <div className="step-form-wrap">
        <h3 className="text-center main-title-text">
          Need Cash Fast? Get an Instant Cash Offer on Your Home Today!
        </h3>
        <div className={className}>
          <div className="steps col-12">
            <span>Step &nbsp;</span>
            <span className="current">{step} </span> &nbsp;/ 11
          </div>
        </div>
        <FormProvider {...methods}>
          <form
            id="leadform"
            className="step-form"
            name="leadform"
            onSubmit={methods.handleSubmit(handleGlobalSubmit)}
            data-tf-element-role="offer"
          >
            <div className="step active" data-step={step}></div>
            <div className="inner">
              {!isEmpty(errors) && (
                <div className="errors">{getErrorMessage(errors)}</div>
              )}
              {
                <>
                  {step === 1 && <FormStep5 />}
                  {step === 2 && <FormStep13 />}
                  {step === 3 && <FormStep1 />}
                  {step === 4 && <FormStep8 />}
                  {step === 5 && <FormStep3 />}
                  {step === 6 && <FormStep4 />}
                  {step === 7 && <FormStep12 />}
                  {step === 8 && <FormStep6 />}
                  {step === 9 && <FormStep10 />}
                  {step === 10 && <FormStep11 />}
                </>
              }
            </div>
            {
              step !== 10 &&
                <EstimateCard/>
            }
          </form>
        </FormProvider>{" "}
      </div>
    </>
  );
}

export default Form;
